import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Конфигурация Firebase для проекта rechat
const firebaseConfig = {
  apiKey: "AIzaSyDI8_SXfEqzcLePLmH9jWseXUoYKcTzApw",
  authDomain: "rechat-e6df8.firebaseapp.com",
  databaseURL: "https://rechat-e6df8-default-rtdb.firebaseio.com",
  projectId: "rechat-e6df8",
  storageBucket: "rechat-e6df8.firebasestorage.app",
  messagingSenderId: "706901289975",
  appId: "1:706901289975:web:abc1b341e251ecf14a9cf2",
  measurementId: "G-KQJRKB8P7F"
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Получение экземпляра базы данных
export const database = getDatabase(app);

export default app;
